/*** IMPORTS FROM imports-loader ***/
var define = false;

"use strict";

var pli = require("../forms");
var pliObservable = require("../forms-knockoutcontrols");
var dateUtil = require("../util/date");

require("../date");

if (require("targetenv").isBrowser) {
    require("./dateForm");
}

var defaultDateFormat = "MMM-dd-yyyy",
    /// <summary>Specifies the default date format</summary>;

    defaultMonthFormat = "MMM-yyyy",
    /// <summary>Specifies the default month format</summary>

    monthParseFormats = [
        "yyyy M", "yy M", "yyyy-M", "yy-M", "yy/M", "yyyyM", "yyM",
        "yyyy MM", "yy MM", "yyyy-MM", "yy-MM", "yy/MM", "yyyyMM", "yyMM",
        "yyyy MMM", "yy MMM", "yyyy-MMM", "yy-MMM", "yy/MMM", "yyyyMMM", "yyMMM",
        "yyyy MMMM", "yy MMMM", "yyyy-MMMM", "yy-MMMM", "yy/MMMM",  "yyyyMMMM", "yyMMMM"];
    /// <summary>Specifies the default parse formats for month/year</summary>


//-------------------------------------------
// Extract the parse formats from the specified
// "behaviourData" or return the default
// (if not specified by "behaviourData").
function getCustomParseFormatsOrDefault(behaviourData, defaultFormat) {
    return (behaviourData && Array.isArray(behaviourData.parseFormats))
        ? behaviourData.parseFormats
        : defaultFormat;
}

//-------------------------------------------
// Serialize a javascript date to the string representation
// of a month. Format: (yyyy-MM) Example. `1999-12`
var toJSONMonth = function toJSONMonth() {
    var month = (this.getMonth() + 1);
    return "".concat(
        this.getFullYear(),
        "-",
        (month < 10 ? "0".concat(month) : month)
    );
};



//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// "DateBehaviour" class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
// Create behaviour for a date type.
function createDateBehaviour(defaultFormat, extraParseFormats, formId, behaviourDataErrorMessageProperty, errorMessage, toJSON) {

    //-------------------------------------------
    function DateBehaviour() {
        return this;
    }


    //-------------------------------------------
    DateBehaviour.prototype.format = function dateBehaviourFormat(value, format) {
        return dateUtil.formatDate(value, format || pliObservable.shared.getCustomFormatOrDefault(this.behaviourData, defaultFormat));
    };


    //-------------------------------------------
    DateBehaviour.prototype.parse = function dateBehaviourParse(value, format) {
        var d = dateUtil.parseDate(
                value,
                format || pliObservable.shared.getCustomFormatOrDefault(this.behaviourData, defaultFormat),
                getCustomParseFormatsOrDefault(this.behaviourData, extraParseFormats)
            );
        return (d === undefined ? DateBehaviour.prototype._getErrorMessage : d);
    };


    //-------------------------------------------
    DateBehaviour.prototype.show = function dateBehaviourShow(options) {
        pli.forms.registry[formId].load({
            value: function (v) {
                return options.onShowDone.call(options.onShowDoneContext, v);
            },
            $element: options.$input
        });
        return false;
    };


    //-------------------------------------------
    DateBehaviour.prototype.validate = function dateBehaviourValidate(value) {
        var isValid = (value === null || dateUtil.isDate(value));

        // Specify custom toJSON function to serialize date without time
        // since time is not specified by the user we should exclude in serialization
        if (isValid && value) {
            value.toJSON = toJSON;
        } // requires DateExtensions.js

        return isValid ? null : DateBehaviour.prototype._getErrorMessage;
    };


    //-------------------------------------------
    DateBehaviour.prototype._getErrorMessage = pliObservable.shared.createGetErrorMessage(behaviourDataErrorMessageProperty, errorMessage);


    return new DateBehaviour();
}


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Initialization
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

module.exports = {
    behaviours: {
        date: createDateBehaviour(defaultDateFormat, null, "dateSelector", "errorDateValue", "Invalid date", Date.prototype.toJSONDate),
        month: createDateBehaviour(defaultMonthFormat, monthParseFormats, "monthSelector", "errorMonthValue", "Invalid month", toJSONMonth)
    }
};




//////////////////
// WEBPACK FOOTER
// ./~/pli/forms-knockoutcontrols-date/knockoutControlsDate.js
// module id = 450
// module chunks = 49